module.exports = ":host #news-listing {\n  margin-top: 10px; }\n\n:host #carousel {\n  margin-top: 5px;\n  margin-bottom: 5px; }\n\n:host .card {\n  margin-bottom: 5px; }\n\n:host .feed-item {\n  margin-top: 15px; }\n\n:host .fa-spinner {\n  font-size: larger; }\n\n:host .carousel-image {\n  border-radius: 8px;\n  padding: 2px;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  vertical-align: central; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = ./src/app/home/home.component.scss
// module chunks = main